import * as firebase from 'firebase'
import "firebase/auth";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAnQjMqTe-JaVguEnD39SAOurFYs0Oh5N0",
  authDomain: "tweetly-a4a14.firebaseapp.com",
  databaseURL: "https://tweetly-a4a14-default-rtdb.firebaseio.com",
  projectId: "tweetly-a4a14",
  storageBucket: "tweetly-a4a14.appspot.com",
  messagingSenderId: "214066388922",
  appId: "1:214066388922:web:b30db23a3ad934f0e84783",
  measurementId: "G-ZE4XPZWGFV"
};


const firebaseApp = firebase.default.initializeApp(firebaseConfig);
export default firebaseApp;